import * as fabric from "fabric";
import { TRACK_EVENT_NAME } from "constants";
import config from "../../config/site.config.json";

export const trackEvent = (action: string, data: string) => {
  try {
    window.thinkingdata.track(TRACK_EVENT_NAME, {
      project: config.trackEventName,
      action,
      data
    })
  } catch (error) {
    console.error('track event error', error)
  }
}

export const TaLogin = (tag: string) => {
  window.thinkingdata.login(tag)
}

export const isWechat = () => {
  return /MicroMessenger/i.test(window.navigator.userAgent);
};

export const isWeibo = () => {
  return /Weibo/i.test(window.navigator.userAgent);
};

// 分享到微博
export const shareToWeibo = (title: string, url: string, imgUrl: string) => {
  return `https://service.weibo.com/share/share.php?title=${normalizeUrlParams(
    title
  )}&url=${url}&pic=${imgUrl}`;
};

const normalizeUrlParams = (param: string): string => {
  return param.replace(/\#/g, "%23");
};

export const isValidateGameAccount = (account: string): boolean => {
  return account.length == 11 && isNaN(Number(account));
};

export const isValidatePhone = (phone: string): boolean => {
  return /^(?:(?:\+|00)86)?1\d{10}$/.test(phone);
};

export const getTimestampInSeconds = () => {
  return Math.floor(Date.now() / 1000)
}


const isMobile = () => {
  if (window == undefined) {
    return false;
  }
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  const isiPad = (/macintosh|mac os x/i.test(navigator.userAgent.toLocaleLowerCase()) && !navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)) || navigator.userAgent.match(/(iPad).*OS\s([\d_]+)/);


  return !!flag || isiPad;
};

export const isPc = () => {
  return !isMobile();
};

export const ShuffleArray = (array: Array<T>) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export const getRandomElement = (array: Array<T>) =>  {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}


export function mirrorObject(eventData, transform) {
  const target = transform.target;
  const canvas = target.canvas;
  target.set("flipX", !target.get("flipX"));
  canvas.requestRenderAll();
}

export function renderIcon(
  ctx,
  left,
  top,
  styleOverride,
  fabricObject,
  imgId,
  renderSize
) {
  const size = renderSize * (ctx.canvas.width / 1500);
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  const rotateIconImg = document.getElementById(imgId);
  ctx.drawImage(rotateIconImg, -size / 2, -size / 2, size, size);
  ctx.restore();
}

export function renderIconRotate(ctx, left, top, styleOverride, fabricObject) {
  return renderIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject,
    "rotateIcon",
    24
  );
}

export function renderIconDel(ctx, left, top, styleOverride, fabricObject) {
  return renderIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject,
    "deleteIcon",
    24
  );
}

export function renderMirrorIcon(ctx, left, top, styleOverride, fabricObject) {
  return renderIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject,
    "mirrorIcon",
    24
  );
}

export function renderIconScale(ctx, left, top, styleOverride, fabricObject) {
  return renderIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject,
    "scaleIcon",
    24
  );
}
